import * as React from 'react';

import { Sellers } from './parts/Sellers';
import { Builders } from './parts/Builders';
import { LayoutBlock } from '../LayoutBlock';
import { Section } from '../Section';
import { INewbuildingSeller } from '../../types/newbuilding/seller';
import { INewbuildingBuilder } from '../../types/newbuilding/builder';

export interface IBuildersInfoProps {
  builders?: INewbuildingBuilder[] | null;
  sellers?: INewbuildingSeller[] | null;
  newbuildingDisplayName?: string;
  isLeadFactory?: boolean;
  trackActionOpenContactsCall(builder: INewbuildingBuilder | INewbuildingSeller): void;
}

export const BuildersInfo: React.FC<IBuildersInfoProps> = props => {
  const { builders, sellers, trackActionOpenContactsCall, newbuildingDisplayName, isLeadFactory } = props;

  const isBuildersHere = builders && builders.length > 0;
  const isSellersHere = sellers && sellers.length > 0;

  if (!isBuildersHere && !isSellersHere) {
    return null;
  }

  return (
    <LayoutBlock data-testid="BuildersInfo">
      <Section id="developer" data-data-nav-tab="developer/Про застройщика" data-mark="BuildersInfo">
        <Builders builders={builders} newbuildingDisplayName={newbuildingDisplayName} />

        {!isLeadFactory && (
          <Sellers
            isPlural={builders && builders.length > 1}
            sellers={sellers}
            trackActionOpenContactsCall={trackActionOpenContactsCall}
          />
        )}
      </Section>
    </LayoutBlock>
  );
};
